/** Valor de `asset_source` ao cadastrar ativo originado da importação DIRPF/IRPF. */
export const IMPORTED_DIRPF_ASSET_SOURCE = "imported_dirpf" as const;

/** Campo opcional para o body de insert quando o fluxo vem da importação (TaxImportDialog com `initialData`). */
export function assetSourceFieldForDirpfImport(
    initialData: unknown
): { asset_source: typeof IMPORTED_DIRPF_ASSET_SOURCE } | undefined {
    if (initialData == null) {
        return undefined;
    }
    return { asset_source: IMPORTED_DIRPF_ASSET_SOURCE };
}

export interface IDirpfImportMeta {
    fields_complete: boolean;
    missing_fields: string[];
    extra_actions: string[];
    requires_user_action_to_register: boolean;
}

/** Ativo com todos os campos obrigatórios e sem pendências para cadastro. */
export function dirpfImportIsComplete(meta?: IDirpfImportMeta | null): boolean {
    if (!meta) {
        return false;
    }
    return (
        meta.fields_complete === true &&
        meta.requires_user_action_to_register === false &&
        (meta.missing_fields?.length ?? 0) === 0 &&
        (meta.extra_actions?.length ?? 0) === 0
    );
}

/** Requer revisão / ajuste do usuário ou cadastro incompleto. */
export function dirpfImportNeedsAttention(meta?: IDirpfImportMeta | null): boolean {
    if (!meta) {
        return false;
    }
    return !dirpfImportIsComplete(meta);
}

export function dirpfImportStatusTooltip(meta?: IDirpfImportMeta | null): string {
    if (!meta) {
        return "Metadados de validação não informados pela importação.";
    }
    if (dirpfImportIsComplete(meta)) {
        return "Dados obrigatórios completos. Pode confirmar o cadastro.";
    }
    const parts: string[] = [];
    if (!meta.fields_complete) {
        parts.push("Campos obrigatórios incompletos.");
    }
    if (meta.requires_user_action_to_register) {
        parts.push("É necessário revisar ou ajustar antes de cadastrar.");
    }
    if (meta.missing_fields?.length) {
        parts.push(`Campos faltantes: ${meta.missing_fields.join(", ")}.`);
    }
    if (meta.extra_actions?.length) {
        parts.push(`Ações sugeridas: ${meta.extra_actions.join(", ")}.`);
    }
    return parts.join(" ");
}
